import { createContext } from 'react';
import generateRandomId from '../../../helpers/generateRandomId';

type ErrorContextType = {
  hasError: boolean;
  errorAutoInvalidate: boolean;
  errorMessageId: string;
};

const ErrorContext = createContext<ErrorContextType>({
  hasError: false,
  errorAutoInvalidate: true,
  errorMessageId: '',
});

export const getErrorMessageId = () => `${generateRandomId()}-error`;

export default ErrorContext;
